import axios from 'axios';

const API_BASE_URL = 'https://backend.gouniquejourneys.co.uk/api/employee/feedbacks'; // Replace with your actual API URL

export const addFeedback = async (feedbackData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/employee-feedback`, feedbackData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`, // If using authentication
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || 'Error submitting feedback';
  }
};

export const getEmployeeFeedback = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/get-employee-feedback`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || 'Error fetching feedback';
  }
};
